import "./OurExpertise.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DfwCanopyCare from "./sections/DfwCanopyCare";
import SafetyFirstStandards from "./sections/SafetyFirstStandards";
import ScheduleAssessment from "./sections/ScheduleAssessment";
import SiteFooter from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <MainNavigation />
      <DfwCanopyCare />
      <SafetyFirstStandards />
      <ScheduleAssessment />
      <SiteFooter />
    </div>;
}